module.exports = [
	{
		"name": "Valuation Ratios",
		"list": [
			{
				"index": 0,
				"value": "ev",
				"definition": "text",
				"label": "EV/EBITDA",
				"absoluteMin": -1000,
				"absoluteMax": 1000000,
				"shortName": "evebitda",
				"min": 0,
				"max": 10,
				"preFix": "",
				"postFix": "",
				"category": "valuation_ratios"
			},
			{
				"index": 3,
				"value": "cap",
				"definition": "text",
				"label": "Market capitalization",
				"absoluteMin": 0,
				"absoluteMax": 1000,
				"shortName": "marketcap",
				"min": 0.5,
				"max": 1000,
				"preFix": "$",
				"postFix": "Billion",
				"category": "valuation"
			},
			{
				"index": 5,
				"value": "pbr",
				"definition": "text",
				"label": "Price to book ratio",
				"absoluteMin": -100,
				"absoluteMax": 100,
				"shortName": "pb",
				"min": 0,
				"max": 5,
				"preFix": "",
				"postFix": "",
				"category": "valuation_ratios"
			},
			{
				"index": 6,
				"value": "per",
				"definition": "text",
				"label": "Price to earning ratio",
				"absoluteMin": -100,
				"absoluteMax": 10000,
				"shortName": "pe1",
				"min": 0,
				"max": 15,
				"preFix": "",
				"postFix": "",
				"category": "valuation_ratios"
			}
		]
	},
	{
		"name": "Solvency",
		"list": [
			{
				"index": 2,
				"value": "dqr",
				"definition": "text",
				"label": "Long-term debt to equity ratio",
				"absoluteMin": -1000000,
				"absoluteMax": 1000000,
				"shortName": "de",
				"min": 0,
				"max": 50,
				"preFix": "",
				"postFix": "%",
				"category": "solvency"
			}
		]
	},
	{
		"name": "Operation Ratios",
		"list": [
			{
				"index": 1,
				"value": "gpm",
				"definition": "text",
				"label": "Gross profit margin",
				"absoluteMin": -100,
				"absoluteMax": 100,
				"shortName": "grossmargin",
				"min": 0,
				"max": 80,
				"preFix": "",
				"postFix": "%",
				"category": "operation_ratios"
			},
			{
				"index": 4,
				"value": "npm",
				"definition": "text",
				"label": "Net profit margin",
				"absoluteMin": -100,
				"absoluteMax": 100,
				"shortName": "netmargin",
				"min": 0,
				"max": 10,
				"preFix": "",
				"postFix": "%",
				"category": "operation_ratios"
			},
			{
				"index": 7,
				"value": "roa",
				"definition": "text",
				"label": "Return on asset",
				"absoluteMin": -100,
				"absoluteMax": 1000000,
				"shortName": "roa",
				"min": 0,
				"max": 20,
				"preFix": "",
				"postFix": "%",
				"category": "operation_ratios"
			},
			{
				"index": 8,
				"value": "roe",
				"definition": "text",
				"label": "Return on equity",
				"absoluteMin": -100,
				"absoluteMax": 1000000,
				"shortName": "roe",
				"min": 0,
				"max": 50,
				"preFix": "",
				"postFix": "%",
				"category": "operation_ratios"
			},
			{
				"index": 9,
				"value": "ric",
				"definition": "text",
				"label": "Return on invested capital",
				"absoluteMin": -100,
				"absoluteMax": 1000000,
				"shortName": "ric",
				"min": 0,
				"max": 50,
				"preFix": "",
				"postFix": "%",
				"category": "operation_ratios"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/views/PickerView/assets/SupportedCriteria.json
// module id = 558
// module chunks = 0